import { INotesSection } from '@modeso/types__aumico-lib-annualreport-be';
import { INotesAccordionComponent } from './notes-accordion-component.interface';

export interface INotesAccordion extends Omit<INotesSection, 'data'> {
    data: INotesAccordionComponent[];
}
